// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.2327 10.1338L6.76855 8.13379L5.76855 9.86584L9.23266 11.8658L10.2327 10.1338ZM14.7686 11.8658L18.2327 9.86584L17.2327 8.13379L13.7686 10.1338L14.7686 11.8658ZM11.9998 13.1998C9.90936 13.1998 8.41835 15.0013 8.0191 17.0043H15.9805C15.5813 15.0013 14.0903 13.1998 11.9998 13.1998Z"}}]};

const Swear1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'swear-1-filled',
    ref,
    icon: element,
  },
));

Swear1FilledIcon.displayName = 'Swear1FilledIcon';

export default Swear1FilledIcon;
